<template>
  <div class="width" @keyup.enter="loginMethod">
    <b-container fluid class="auth">
      <!-- div class="container text-center">
        <div class="row">
          <div class="col-7 col-md-2 mx-auto mb-6">
            <img src="../assets/nova-logo.svg" class="logo" alt="Логотип ИМС Нова"/>
          </div>
        </div>
      </div -->
      <div class="d-flex justify-content-center align-items-center">
        <img style="margin-right: 18px;" src="../assets/logo.svg" class="logo mb-3" alt="Логотип ИМС Нова"/>
        <h3 class="center" style="font-size: 1.425rem; font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif !important;">ИМС Нова</h3>
        <div class="vertslash">
          <h3 class="center" style="font-size: 1.425rem; font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif !important;">|</h3>
        </div>
        <h3 class="center" style="font-size: 1.425rem; font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif !important;">Личный кабинет дилера</h3>
      </div>
      <!-- h3 class="center">Войти в личный кабинет дилера</h3 -->
      <b-form class="login" @submit.prevent="loginMethod">
        <b-row class="my-1 b-center">
          <b-col md="3" class="mb-1">
            <b-form-input id="input-none" :state="true" type="text" placeholder="Логин"
                          v-model="form.username" required></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1 b-center">
          <b-col md="3">
            <b-form-input id="input-valid" :state="true" type="password" placeholder="Пароль"
                          v-model="form.password" required></b-form-input>
            <span :class="showPassword?'show-password':'hide-password'" @click="togglePassword"></span>
          </b-col>
        </b-row>
        <b-row class="b-center" v-show="status==='error'">
          <b-col md="auto">
            <b-alert show variant="danger-light" class="border-0">Пожалуйста, проверьте правильность написания логина и пароля.
            </b-alert>
          </b-col>
        </b-row>
        <b-row class="b-center">
          <b-col md="2">
            <b-button @click="loginMethod" id="log_in" class="login" variant="success">Войти</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-container>
    <div class="footer-info">
      <div><p>&copy; ООО &laquo;Даобит&raquo; {{ new Date().getFullYear() }}</p></div>
      <div v-if="false"><a target="_blank" href="https://www.daobit.ru/privacy.pdf">Политика обработки персональных данных и реализуемых требований к их защите в ООО «Даобит» (PDF)</a></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'log-in',
  data () {
    return {
      showPassword: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  mounted () {
    if (localStorage.getItem('token_citadel_authorization')) {
      localStorage.removeItem('token_citadel_authorization')
    }
    if (localStorage.getItem('citadelUserInfo')) {
      localStorage.removeItem('citadelUserInfo')
    }
    if (axios.defaults.headers.common.Authorization) {
      delete axios.defaults.headers.common.Authorization
    }
  },
  computed: {
    ...mapState({
      status: state => state.authorization.status
    })
  },
  methods: {
    ...mapActions('authorization',
      [
        'login',
        'showUserInfo'
      ]
    ),
    loginMethod () {
      this.login(this.form).then(
        () => {
          this.showUserInfo().then(
            () => {
              this.$router.push('/')
            },
            error => {
              console.log(error)
            }
          )
        },
        error => {
          console.log(error)
        }
      )
    },
    togglePassword () {
      const inputPass = document.getElementById('input-valid')
      if (inputPass.type === 'password') {
        inputPass.type = 'text'
        this.showPassword = !this.showPassword
      } else {
        inputPass.type = 'password'
        this.showPassword = !this.showPassword
      }
    }
  }
}
</script>

<style scoped lang="scss">
  h3.center {
    text-align: center;
    /* margin-bottom: 30px; */
  }

  .auth {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .logo {
      height: 24px;
    }
  }

  .width {
    width: 100vw;
    background-color: #f5f4f4;
    height: 100vh;
    display: flex;
    position: relative;
  }

  .login {
    min-width: 65px;
    text-align: center;
  }

  .login button {
    width: 100%;
  }

  .b-center {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .alert {
    margin-bottom: 0;
    padding: 1.25rem 1.25rem;
  }

  span {
    width: 25px;
    height: 20px;
    display: block;
    position: absolute;
    top: 0.6rem;
    right: 1.25rem;
    &.show-password {
      background-image: url("../assets/icon-eye-close.svg");
      background-repeat: no-repeat;
    }
    &.hide-password {
      background-image: url("../assets/icon-eye-open.svg");
      background-repeat: no-repeat;
    }
  }

  .footer-info {
    position: absolute;
    bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    width: 100%;
  }

  .vertslash {
    display: block;
    margin: 0 10px 0 10px;
    position: relative;
    & h2 {
      position: absolute;
      top: -16px;
    }
  }
</style>
